// extracted by mini-css-extract-plugin
module.exports = {"icon":"custom-multi-select-icon__1SQ9F","icon_active":"custom-multi-select-icon_active__3ZJ1u"};